var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { span: 24 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Possui CAR?",
                  content: _vm.imovel.possuiCar ? "Sim" : "Não"
                }
              })
            ],
            1
          ),
          _vm.imovel.numeroReciboCar
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: _vm.labelImovel.numeroRecibo,
                      content: _vm.imovel.numeroReciboCar,
                      marginBottom: true
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.imovel.viasDeAcesso
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Roteiro de acesso:",
                      content: _vm.imovel.viasDeAcesso
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.imovel.nome
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Nome do Imóvel:",
                      content: _vm.imovel.nome
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.imovel.gleba
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: { label: "Gleba:", content: _vm.imovel.gleba }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.imovel.area
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Área:",
                      content:
                        _vm.formatterDecimal(_vm.imovel.area) + " hectare(s)"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _vm.imovel.descricaoAcesso
                ? _c("app-display", {
                    attrs: {
                      label: "Descrição de acesso:",
                      content: _vm.imovel.descricaoAcesso
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Há eletrificação no imóvel?",
                  content: _vm.imovel.possuiEletrificacao ? "Sim" : "Não"
                }
              })
            ],
            1
          ),
          _vm.imovel.tipoEletrificacao
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Qual o tipo de eletrificação?",
                      content: _vm.imovel.tipoEletrificacao
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Possui acesso à rodovias no imóvel?",
                  content: _vm.imovel.possuiAcessoRodovia ? "Sim" : "Não"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Qual o tipo de acesso à rodovia?",
                  content: _vm.imovel.tipoAcessoRodovia
                }
              })
            ],
            1
          ),
          _vm.imovel.possuiAcessoRodovia === true
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "O acesso pela rodovia é pavimentado?",
                      content: _vm.imovel.isRodoviaPavimentada
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label:
                    "Tem interesse ecológico para preservação de ecossistemas?",
                  content: _vm.imovel.possuiInteresseEcologico ? "Sim" : "Não"
                }
              })
            ],
            1
          ),
          _vm.imovel.possuiInteresseEcologico === true
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "O acesso pela rodovia é pavimentado?",
                      content: _vm.imovel.interessesEcologicos
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Tem projeto de recuperação da área degradada?",
                  content: _vm.imovel.possuiProjetoRecuperacao ? "Sim" : "Não"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Tem efetiva recuperação de área degradada?",
                  content: _vm.imovel.isRecuperacaoAreaDegradada ? "Sim" : "Não"
                }
              })
            ],
            1
          ),
          _vm.imovel.areaCerrado
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Área cerrado (ha):",
                      content: _vm.imovel.areaCerrado
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.imovel.areaReservaLegalCerrado
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Área de Reserva Legal cerrado (ha):",
                      content: _vm.imovel.areaReservaLegalCerrado
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.imovel.porcentagemCerrado
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Porcentagem cerrado (%):",
                      content: _vm.imovel.porcentagemCerrado
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.imovel.areaFloresta
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Área floresta (ha):",
                      content: _vm.imovel.areaFloresta
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.imovel.areaReservaLegalFloresta
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Área de Reserva Legal floresta (ha):",
                      content: _vm.imovel.areaReservaLegalFloresta
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.imovel.porcentagemFloresta
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Porcentagem floresta (%):",
                      content: _vm.imovel.porcentagemFloresta
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f0fa8a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f0fa8a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/InformacoesImovelRr.vue
// module id = null
// module chunks = 